export { default } from "./SearchResultsItem";
export type { SearchResultsItemProps } from "./SearchResultsItem";
